
import {pertuntas} from './error-messages/perguntas';
import {user} from './error-messages/usuarios';


export const ReplaceErrorList: object = {
  ...pertuntas,
  ...user
}
